import {Incentive} from '@volkswagen-onehub-cms/cms-victor-bff';
import {replaceTranslationPlaceholders} from '../../../utils/translation/replaceTranslationPlaceholders';
import {LocaleModel} from '../../../../generated/core';
import {Logger} from '../../../context/logger/Logger';

export function createDescriptionText(
    validityPattern: string,
    incentive: Incentive,
    locale: LocaleModel,
    logger: Logger
) {
    if (!validityPattern) {
        return undefined;
    }
    try {
        const validityText = replaceTranslationPlaceholders(validityPattern, {
            from: formatDate(
                incentive.validity.customerAllocationPeriod.from,
                locale
            ),
            to: formatDate(
                incentive.validity.customerAllocationPeriod.to,
                locale
            )
        });

        const descriptionText = `${incentive.limitation} ${validityText}`;
        return descriptionText;
    } catch (e) {
        logger.incentive.error(
            'failed to format date in description of incentive'
        );
        return '';
    }
}

function formatDate(isoDateString: string, localeModel: LocaleModel) {
    const date = new Date(isoDateString);

    const locale =
        localeModel.language.toLowerCase() +
        '-' +
        localeModel.countryCode.toUpperCase();

    return new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }).format(date);
}
